import { render, staticRenderFns } from "./announcementClass.vue?vue&type=template&id=08d2318a&scoped=true&"
import script from "./announcementClass.vue?vue&type=script&lang=js&"
export * from "./announcementClass.vue?vue&type=script&lang=js&"
import style0 from "./announcementClass.vue?vue&type=style&index=0&id=08d2318a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2318a",
  null
  
)

export default component.exports